// グローバルメソッドのインポート
import NativeHandlerMixin from "@/mixins/Common/NativeHandlerMixin";
import CommonDataMixin from "@/mixins/Common/CommonDataMixin";
import CommonMethodsMixin from "@/mixins/Common/CommonMethodsMixin";
import CommonComputedMixin from "@/mixins/Common/CommonComputedMixin";
import EventPreventMixin from "@/mixins/Common/EventPreventMixin";
import WindowMixin from "@/mixins/Common/WindowMixin";

export default {
  mixins: [
    NativeHandlerMixin,
    CommonDataMixin,
    CommonMethodsMixin,
    CommonComputedMixin,
    EventPreventMixin,
    WindowMixin,
  ],
};
